import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cartera',
  templateUrl: './cartera.component.html',
  styleUrls: ['./cartera.component.scss'],
})
export class CarteraComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
